export default "__VITE_ASSET__DJzwMSPr__"